import {React, useState, useContext, Link, FC} from 'external/react'
import {styled, Button, Menu, MenuItem, KeyboardArrowDownIcon, clsx} from 'external/material'

import { TeacherContext } from 'teacher/context'

import { saveTemplateDialog } from './SaveTemplateDialog'

type TemplatesMenuProps = {
  rd?: boolean
}

const StyledTemplatesMenu = styled('div')(templatesMenuStyles as any)

const TemplatesMenu: FC<TemplatesMenuProps> = (props) => {

  const {rd=false} = props

  const context = useContext(TeacherContext) as any
  const {link, match, translate} = context

  const [anchorEl, setAnchorEl] = useState(null)

  function handleClick(event: any){
    setAnchorEl(event.currentTarget)
  }

  function handleClose() {
    setAnchorEl(null);
  }

  return (
    <StyledTemplatesMenu className="templates-menu">
      <Button
        aria-controls="customized-menu"
        aria-haspopup="true"
        variant="contained"
        className="add"
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        {translate("templates_label")}
      </Button>
      <Menu
        elevation={0}
        className="menu"
        anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
        transformOrigin={{vertical: 'top', horizontal: 'left'}}
        id="add-field-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem disableGutters={true} className="item" onClick={() => {
          saveTemplateDialog({rd, context})
          handleClose()
        }}>
          {translate("save_as_template")}
        </MenuItem>
        <MenuItem disableGutters={true} className={clsx("item", "manage-templates")}
          component={Link}
          to={link({},`${match.path}/templates`,{preserveQuery: true})}
        >
          {translate("manage_templates")}
        </MenuItem>
      </Menu>
    </StyledTemplatesMenu>
  )
}

function templatesMenuStyles () {
  return {
    "& .add": {
      color: '#4e576e',
      background: '#fff',
      textTransform: 'none',
      '&:hover': {
        background: '#eaf5ff'
      }
    },
    "& .item": {
      minWidth: '200px',
      color: '#4e576e',
      padding: '10px',
      '&:hover': {
        color: '#fff',
        background: '#2993ff'
      }
    }
  }
}

export  {TemplatesMenu as default}